import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { initialState, searchProjecten } from '../services/searchProjecten'

import { useProjectenSearchStore } from './useProjectenSearchStore'

export { useProjectenSearch, queryKey }

const queryKey = 'hoofdleiding-projecten'

const useQueryStore = () => {
  const { query, storeQuery } = useProjectenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useProjectenSearch = () => {
  const {
    onChangeFilters,
    onReset,
    query,
    onChangePage,
    onChangeSort,
    onRemoveSort,
    onRestoreSort,
  } = useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()
  const [previousSort, setPreviousSort] = useState<typeof query.sort>()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchProjecten({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  const onChangeFiltersWithRemoveSort = (
    filters: typeof query.filters,
    removeSort?: boolean,
  ) => {
    if (removeSort) {
      onRemoveSort(filters)
      setPreviousSort(query.sort)
      return
    }

    if (!removeSort && previousSort) {
      onRestoreSort(filters, previousSort)
      setPreviousSort(undefined)
      return
    }

    onChangeFilters(filters)
  }

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters: onChangeFiltersWithRemoveSort,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
